export const invalidControlSx = {
  "& .MuiFilledInput-root": {
    borderColor: "error.main",
    "&:hover, &.Mui-focused": { borderColor: "error.main" },
    "&::after": { borderBottomColor: "error.main" },
    "&.Mui-disabled": { borderColor: "rgba(211, 47, 47, 0.5)" },
  },
  "& .MuiOutlinedInput-root": {
    "& .MuiOutlinedInput-notchedOutline": { borderColor: "error.main" },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "error.main",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "error.main",
    },
    "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(211, 47, 47, 0.5)",
    },
  },
} as const;
